module.exports = __webpack_public_path__ + "static/media/002-online-shop.226dac62.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/common/icon/002-online-shop.png
// module id = 681
// module chunks = 0